import { _post, _get } from "./Axios";

export default class AuthApi {
  static login(data) {
    return _post("auth/login/", data);
  }
  static logout() {
    return _post("auth/logout/");
  }
  static register(data) {
    return _post("auth/register/", data)
  }
  static forgotpassword(data) {
    return _post("auth/forgotpassword/", data)
  }
  static check_token(data) {
    return _post("auth/checktoken/", data);
  }
  static checkverificationtoken(token) {
    return _get("auth/verification/" + token);
  }
  static verification(token, data) {
    return _post("auth/verification/" + token, data);
  }
}
